<script>
export default {
  name: 'ElementAutoLink',
  props: {
    text: String
  },
  render: function (createElement) {
    if (this.text === null || this.text === '') {
      return createElement('span')
    }
    const tmp = this.text.split(/(https?:\/\/[\w!?/+\-_~=;.,*&@#$%()'[\]]+)/i)
    const vnodes = tmp.map(function(x, i) {
      if (i % 2) {
        return createElement('a', { attrs: { href: x, target: '_blank', class: 'autolink' } }, x)
      } else {
        return this._v(x)
      }
    }, this)
    return createElement(
      'span',
      vnodes
    )
  }
}
</script>
<style>
.autolink {
  word-break: break-all;
}
</style>
